import React, { useState, useCallback, useEffect } from 'react';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  IconButton,
  Modal,
  Paper, Pagination
} from "@mui/material";
import config from "../../../../aws-exports";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import { useLoading } from "../../../../context/LoadingContext";
import SearchFilter from '../../../Requirement/components/common/SearchFilter';
import DataTable from '../../../Requirement/components/common/ReusableTable';
import { fetchData, uploadFileToS3, searchfetchQueries, uploadVideoToS3 } from '../../../Requirement/services/RequirementServices';
import { v4 as uuidv4 } from "uuid";
import AlertModal from '../../../Requirement/components/common/AlerModel';
import dayjs from 'dayjs';
import { Autocomplete } from "@mui/material";
import { jwtDecode } from 'jwt-decode';

const RaisedTicket = () => {
  const [formData, setFormData] = useState({
    IssueCategory: '',
    Subject: '',
    Description: '',
    Attachment: null,
    Remarks: '',
  });
  const category = [
    { "key": "KYCVerification", "value": "KYC Verification" },
    { "key": "PaymentIssue", "value": "Payment Issue" },
    { "key": "Product/OfferIssue", "value": "Product/Offer Issue" },
    { "key": "TechnicalProblem", "value": "Technical Problem" },
    { "key": "AccountAccess/Login", "value": "Account Access/Login" },
    { "key": "Other", "value": "Others" }
  ];
  const [tempOtherFiles, setTempOtherFiles] = useState([]);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const [errors, setErrors] = useState({});
  const [searchValues, setSearchValues] = useState({
    ticketSubject: "",
    category: "",
    status: ""
  });
  const navigate = useNavigate();
  const [activeUser, setActiveUser] = useState("");
  const [documentVaultUserFiles, setDocumentVaultUserFiles] = useState([]);
  const [OtherFilesDocumentValut, setOtherFilesDocumentValut] = useState(false);
  const [openFilesModal, setOpenFilesModal] = useState(false);
  const { loading, setLoading } = useLoading();
  const [submitted, setSubmitted] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ticketList, setTicketList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [documentCategoryMaster, setDocumentCategoryMaster] = useState([]);
  const [selectedVaultFile, setSelectedVaultFile] = useState(null);
  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  const filePath = `public/media/amtpl/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  const handleModalClose = () => {
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
  };

  const handleAddDocOtherFile = useCallback(() => {
    setOtherFilesDocumentValut(true);
    setTempOtherFiles([]);
  }, []);

  const handleBackToUploadOptions = () => {
    setOtherFilesDocumentValut(false);
    setTempOtherFiles([]);
    setSelectedVaultFile(null);
  };

  const handleCloseFilesModal = useCallback(() => {
    setOpenFilesModal(false);
    setOtherFilesDocumentValut(false);
    setTempOtherFiles([]);
    setSelectedVaultFile(null);
  }, []);

  const handleOpenFilesModal = useCallback(() => {
    setOpenFilesModal(true);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleConfirmOtherFiles = useCallback(() => {
    if (tempOtherFiles.length === 0) {
      setModal({
        show: true,
        type: "error",
        title: "No File Selected",
        message: "Please select at least one file.",
        autoClose: false,
      });
      return;
    }
    if (tempOtherFiles.length > 1) {
      setModal({
        show: true,
        type: "error",
        title: "Too Many Files",
        message: "Only one file can be uploaded at a time.",
        autoClose: false,
      });
      return;
    }
    const validFiles = tempOtherFiles.filter((file) => file !== null);
    console.log("Selected File:", validFiles[0]);
    setFormData((prev) => ({
      ...prev,
      Attachment: validFiles[0],
    }));
    setOpenFilesModal(false);
    setOtherFilesDocumentValut(false);
    setTempOtherFiles([]);
    setSelectedVaultFile(null);
  }, [tempOtherFiles]);

  const handleTempOtherFileChange = useCallback(
    (index, event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          setModal({
            show: true,
            type: "error",
            title: "Invalid File",
            message: "Please upload a PDF file.",
            autoClose: false,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          setModal({
            show: true,
            type: "error",
            title: "File Too Large",
            message: "File size must not exceed 2MB.",
            autoClose: false,
          });
          return;
        }
        setTempOtherFiles([file]);
      }
    },
    []
  );

  const handleAddTempOtherFile = useCallback(() => {
    if (tempOtherFiles.length === 0) {
      setTempOtherFiles([null]);
    }
  }, [tempOtherFiles]);

  const handleRemoveTempOtherFile = useCallback(
    (index) => {
      setTempOtherFiles([]);
    },
    []
  );

  const getBuyerInfo = useCallback(async (buyerEmail) => {
    try {
      const response = await fetchData({
        target: "listAMTPLUsers",
        userOrder: "AMTPLUserID",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { EmailID: buyerEmail },
      });
      setBuyerInfo(response.items || []);
    } catch (error) {
      console.error("Error loading buyer info:", error);
      setBuyerInfo([]);
    }
  }, []);

  const loadDocumentCategories = useCallback(async () => {
    try {
      const response = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "DocCategory" },
      });
      console.log("Document Categories:", response);
      setDocumentCategoryMaster(response.items || []);
    } catch (error) {
      console.error("Error loading document categories:", error);
      setDocumentCategoryMaster([]);
    }
  }, []);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut();
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email);
          getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/global-partner");
      }
    };
    checkUser();
    loadDocumentCategories();
  }, [navigate, getBuyerInfo, loadDocumentCategories]);

  const loadUserDocumentVault = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listUserDocument",
          userOrder: "DocumentId",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { CreatedBy: activeUser },
        }),
      ]);
      const totalCounts = initialResponse?.total || initialResponse?.items?.length || 0;
      console.log("Initial Response:", initialResponse);
      if (totalCounts > 0) {
        const [allDocs] = await Promise.all([
          searchfetchQueries({
            target: "listUserDocument",
            userOrder: "DocumentId",
            rowStart: 0,
            pageSize: 1000,
            filterTerms: { CreatedBy: activeUser },
          }),
        ]);
        console.log("All Documents:", allDocs);
        setDocumentVaultUserFiles(allDocs || []);
      } else {
        setDocumentVaultUserFiles([]);
        setModal({
          show: true,
          type: "info",
          title: "No Documents",
          message: "No documents found in your vault.",
          autoClose: false,
        });
      }
    } catch (error) {
      console.error("Error loading user document vault files:", error);
      setDocumentVaultUserFiles([]);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to load documents from vault.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  }, [setLoading, activeUser, setModal]);

  useEffect(() => {
    if (openFilesModal && OtherFilesDocumentValut && activeUser) {
      loadUserDocumentVault();
    } else if (openFilesModal && OtherFilesDocumentValut && !activeUser) {
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "User not authenticated. Please log in again.",
        autoClose: false,
      });
    }
  }, [openFilesModal, OtherFilesDocumentValut, activeUser, loadUserDocumentVault, setModal]);

  const loadIssueTicketList = useCallback(
    async (filters, newRowStart = rowStart) => {
      setLoading(true);
      try {
        const response = await fetchData({
          target: "listSupportTicket",
          userOrder: "CreatedAt DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          EmailID: activeUser,
          filterTerms: {
            ...(filters.ticketSubject && { Subject: filters.ticketSubject }),
            ...(filters.category && { IssueCategory: filters.category }),
            ...(filters.status && { Status: filters.status }),
          },
        });

        console.log("API Response:", response); // Debug API response
        const modifiedItems = (response.items || response).map((item) => ({
          ...item,
          id: item.TicketID,
        }));
        setTicketList(modifiedItems);
        setTotalItems(response?.total || modifiedItems.length || 0);
      } catch (error) {
        console.error("Error loading tickets:", error);
        setTicketList([]);
        setTotalItems(0);
        setModal({
          show: true,
          type: "error",
          title: "Error",
          message: "Failed to load tickets. Please try again.",
          autoClose: false,
        });
      } finally {
        setLoading(false);
      }
    },
    [setLoading, pageSize, activeUser, setModal]
  );

  useEffect(() => {
    if (activeUser) {
      setRowStart(0);
      setTotalItems(0);
      loadIssueTicketList(searchValues, 0);
    }
  }, [searchValues, activeUser, loadIssueTicketList]);

  const handleAdd = () => {
    setFormData({
      IssueCategory: '',
      Subject: '',
      Description: '',
      Attachment: null,
    });
    setIsEditMode(true);
    setIsFormVisible(true);
  };

  const handleRowClick = (row) => {
    setIsEditMode(false);
    setIsFormVisible(true);
    setSelectedRow(row);
    setFormData({
      IssueCategory: row.IssueCategory || '',
      Subject: row.Subject || '',
      Description: row.Description || '',
      Attachment: row.Attachment || null,
      Remarks: row.Remarks || null,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.IssueCategory) newErrors.IssueCategory = "Issue category is Required";
    if (!formData.Subject) newErrors.Subject = "Subject / Title is Required";
    if (!formData.Description) newErrors.Description = "Description is Required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      let uploadedFileName = null;
      console.log(formData.Attachment);
      if (formData.Attachment) {
        if (formData.Attachment instanceof File) {
          const fileresult = await uploadVideoToS3(formData.Attachment);
          console.log(fileresult, "fileresult");
          if (fileresult?.fileName) {
            uploadedFileName = fileresult.fileName;
          } else {
            throw new Error("File upload to S3 failed.");
          }
        } else if (formData.Attachment?.DocumentFile) {
          uploadedFileName = formData.Attachment.DocumentFile;
          console.log(uploadedFileName);
        } else {
          throw new Error("Invalid attachment format.");
        }
      }
      const payload = {
        target: "createSupportTicket",
        supportTicketInput: {
          TicketID: uuidv4(),
          Status: "Pending",
          IssueCategory: formData.IssueCategory,
          Subject: formData.Subject,
          Description: formData.Description,
          Attachment: uploadedFileName,
          Remarks: formData.Remarks,
          EmailID: activeUser
        },
      };

      const response = await fetchData(payload);
      console.log(response.items);
      if (response) {
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: "Ticket created successfully.",
          autoClose: false,
        });
        setRowStart(0);
        loadIssueTicketList(searchValues, 0);
      }
    } catch (error) {
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || "Failed to submit.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
      setSubmitted(true);
      setIsFormVisible(false);
      setFormData({
        IssueCategory: '',
        Subject: '',
        Description: '',
        Attachment: null,
      });
      setIsEditMode(false);
      setSelectedRow(null);
    }
  };

  const fields = [
    {
      name: "ticketSubject",
      label: "Ticket Subject",
      type: "text",
      onChange: (value) => setSearchValues((prev) => ({ ...prev, ticketSubject: value })),
      value: searchValues.ticketSubject,
    },
    {
      name: "category",
      label: "Category",
      type: "dropdown",
      options: category.map((cat) => ({ value: cat.key, label: cat.value })),
      onChange: (value) => setSearchValues((prev) => ({ ...prev, category: value })),
      value: searchValues.category,
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: ["Pending", "Resolved", "Open"],
      onChange: (value) => setSearchValues((prev) => ({ ...prev, status: value })),
      value: searchValues.status,
    },
  ];

  const columns = [
      { id: "TicketNo", numeric: false, label: "Ticket No" },
        {
          id: "Subject",
          numeric: false,
          label: "Subject",
          renderCell: (row) => row?.Subject ? row.Subject.slice(0, 10) + (row.Subject.length > 10 ? "..." : "") : ""
        },
        { id: "IssueCategory", numeric: false, label: "Category" },
        {
          id: "CreatedBy",
          numeric: false,
          label: "Created By",
          // renderCell: (row) => row?.CreatedBy ? row.CreatedBy.slice(0, 10) + (row.CreatedBy.length > 10 ? "..." : "") : ""
        },
        {
          id: "Status",
          numeric: false,
          label: "Status",
          renderCell: (row) => {
            let bgColor = "", textColor = "";
            switch (row.Status) {
              case "Pending": bgColor = "#fef3c7"; textColor = "#b45309"; break;
              case "Resolved": bgColor = "#d1fae5"; textColor = "#065f46"; break;
              case "Open": bgColor = "#e0f2fe"; textColor = "#0369a1"; break;
              default: bgColor = "#f3f4f6"; textColor = "#374151";
            }
            return (
              <span
                style={{
                  backgroundColor: bgColor,
                  color: textColor,
                  padding: "4px 10px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 500
                }}
              >
                {row?.Status || ""}
              </span>
            )
          }
        },
        {
          id: "CreatedAt",
          numeric: false,
          label: "Created At",
          renderCell: (row) =>
            row.CreatedAt
              ? dayjs(row.CreatedAt).format("DD/MM/YYYY")
              : "",
        }
    ];

  const handleSearch = (searchValues) => {
    setRowStart(0);
    setTotalItems(0);
    loadIssueTicketList(searchValues, 0);
  };

  const handlePageChange = (event, newPage) => {
    console.log()
    const newRowStart = (newPage - 1) * pageSize;
    setRowStart(newRowStart);
    console.log(newRowStart)
    loadIssueTicketList(searchValues, newRowStart);
  };

  // Optional: Handle dynamic page size changes if supported by DataTable
  const handleRowsPerPageChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setRowStart(0); // Reset to first page
    setTotalItems(0);
    loadIssueTicketList(searchValues, 0);
  }, [searchValues, loadIssueTicketList]);
  const pageCount = Math.ceil(totalItems / pageSize);
  const currentPage = Math.floor(rowStart / pageSize) + 1;

  return (
    <div className="container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="table-header-re">
        <div className="head-btn">
          {!isFormVisible && <button className="submit-btn-more" onClick={handleAdd}>Add New Ticket</button>}
        </div>
      </div>

      <Paper elevation={2} sx={{ p: 3 }}>
        <div className="search-filter4">
          <div className="title4">
            <div className="head-text">Raised Ticket</div>
          </div>
          <div className="filter4">
            <SearchFilter fields={fields} onSearch={handleSearch} />
          </div>
        </div>

        <div className="table-content">
          <DataTable
            columns={columns}
            data={ticketList}
            onRowClick={handleRowClick}
            // total={totalItems}
            // title="Information"
            // rowsPerPage={pageSize}
            // onPageChange={handlePageChange}
            // onRowsPerPageChange={handleRowsPerPageChange} // Optional, if DataTable supports it
            // currentPage={currentPage}
            selectedRows={selectedRow ? [selectedRow.id] : []}
          />
        </div>
        <div className="pagination mt-6 flex justify-center">
          <Pagination
            count={pageCount}
            page={currentPage}
            onChange={handlePageChange}
            sx={{
              "& .MuiPaginationItem-root": {
                backgroundColor: "#f0f0f0",
                "&.Mui-selected": {
                  backgroundColor: "#de6b14",
                  color: "#fff",
                },
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                  color: "#de6b14",
                },
              },
            }}
          />
        </div>
        {isFormVisible && (
          <div className='raise-ticket card mb-3 p-4'>
            <div className="table-header">
              <div className="header-text">
                <div className="head-text">{isEditMode ? "Submit a new support ticket." : "Ticket Details"}</div>
              </div>
              <div className="head-btn">
                <div className="submit-btn-form" style={{ display: 'flex', gap: '10px' }}>
                  {isFormVisible && <button className="submit-btn-more" onClick={() => setIsFormVisible(false)}>Cancel</button>}
                  {isEditMode && (
                    <button
                      className="submit-btn-more"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : submitted ? 'Submit' : 'Submit'}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <form id="ticketForm">
              <div className="row gx-3">
                <FormControl className="col-md-6 mb-3" sx={{ pr: 1 }} error={!!errors.IssueCategory}>
                  <Typography variant="body2" gutterBottom>Issue Category</Typography>
                  <Select
                    name="IssueCategory"
                    value={formData.IssueCategory}
                    onChange={handleChange}
                    displayEmpty
                    sx={{ backgroundColor: 'white' }}
                    disabled={!isEditMode}
                  >
                    <MenuItem value="" disabled>Select a category...</MenuItem>
                    <MenuItem value="KYCVerification">KYC Verification</MenuItem>
                    <MenuItem value="PaymentIssue">Payment Issue</MenuItem>
                    <MenuItem value="Product/OfferIssue">Product/Offer Issue</MenuItem>
                    <MenuItem value="TechnicalProblem">Technical Problem</MenuItem>
                    <MenuItem value="AccountAccess/Login">Account Access/Login</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {errors.IssueCategory && <FormHelperText>{errors.IssueCategory}</FormHelperText>}
                </FormControl>

                <FormControl className="col-md-6 mb-3" sx={{ pl: 1 }} error={!!errors.Subject}>
                  <Typography variant="body2" gutterBottom>Subject / Title</Typography>
                  <TextField
                    name="Subject"
                    value={formData.Subject}
                    onChange={handleChange}
                    placeholder="Enter subject or title"
                    fullWidth
                    sx={{ backgroundColor: 'white' }}
                    disabled={!isEditMode}
                  />
                  {errors.Subject && <FormHelperText>{errors.Subject}</FormHelperText>}
                </FormControl>

                <FormControl fullWidth className="mb-3" error={!!errors.Description}>
                  <Typography variant="body2" gutterBottom>Description</Typography>
                  <textarea
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                    placeholder="Description"
                    fullWidth
                    sx={{ backgroundColor: 'white', mb: 2, borderColor: "#ccc", borderRadius: "5px !important" }}
                    rows="7"
                    disabled={!isEditMode}
                  />
                  {errors.Description && <FormHelperText>{errors.Description}</FormHelperText>}
                </FormControl>
                {formData.Remarks ? <><FormControl fullWidth className="mb-3" >
                  <Typography variant="body2" gutterBottom>Remarks</Typography>
                 <textarea
                    name="Remarks"
                    value={formData.Remarks || ""}
                    fullWidth
                    sx={{ backgroundColor: 'white', mb: 2, borderColor: "#ccc", borderRadius: "5px !important", padding:"4px" }}
                    rows="7"
                    disabled={true}
                  />
                  
                </FormControl></>: ''}
                
                <FormControl className="col-md-6 mb-3" sx={{ pl: 1 }}>
                  <Typography variant="body2" gutterBottom>Attachments (image / PDF)</Typography>
                  {isEditMode && (
                    <Button
                      variant="outlined"
                      onClick={handleOpenFilesModal}
                      sx={{
                        border: "1px solid #FF5722",
                        color: "#FF5722",
                        textTransform: "capitalize",
                        width: "180px",
                      }}
                    >
                      Select File
                    </Button>
                  )}
                  {formData.Attachment && (
                    <div style={{ marginTop: "10px", justifyContent: "space-between", marginBottom: "8px", display: "flex", alignItems: "center", background: "#cccccc42", padding: "0 5px", borderRadius: "5px" }}>
                      {formData.Attachment instanceof File ? (
                        <Typography variant="body2">{formData.Attachment.name}</Typography>
                      ) : formData.Attachment?.DocumentName ? (
                        <Typography variant="body2">{formData.Attachment.DocumentName}</Typography>
                      ) : selectedRow?.Attachment && !isEditMode ? (
                        <a
                          href={fileUrl + selectedRow.Attachment}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View current attachment
                        </a>
                      ) : null}
                      {isEditMode && formData.Attachment && (
                        <IconButton
                          onClick={() => setFormData((prev) => ({ ...prev, Attachment: null }))}
                          sx={{ ml: 1, width: "40px" }}
                        >
                          <CloseIcon sx={{ color: "#555", width: "18px" }} />
                        </IconButton>
                      )}
                    </div>
                  )}
                </FormControl>
              </div>
            </form>
          </div>
        )}
      </Paper>

      <Modal open={openFilesModal} onClose={handleCloseFilesModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">Upload Other Files</Typography>
            <IconButton onClick={handleCloseFilesModal}>
              <CloseIcon />
            </IconButton>
          </Box>

          {OtherFilesDocumentValut ? (
            <>
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>

              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    console.log("Selected Category:", newValue);
                    setSelectedVaultFile(newValue);
                    setTempOtherFiles([]);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": { borderColor: "#ccc" },
                          "&:hover fieldset": { borderColor: "#ff9800" },
                          "&.Mui-focused fieldset": { borderColor: "#fb8c00" },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": { backgroundColor: "#fff3e0" },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>

              {selectedVaultFile ? (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  {loading ? (
                    <Typography variant="body2" sx={{ color: "#666" }}>
                      Loading documents...
                    </Typography>
                  ) : (
                    <Autocomplete
                      options={documentVaultUserFiles.filter(
                        (doc) => doc.Category?.toLowerCase() === selectedVaultFile.Value?.toLowerCase()
                      )}
                      getOptionLabel={(option) => option.DocumentName || ""}
                      onChange={(event, newValue) => {
                        console.log("Selected Document:", newValue);
                        if (newValue) {
                          setTempOtherFiles([newValue]);
                        } else {
                          setTempOtherFiles([]);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Type to search documents..."
                          variant="outlined"
                          sx={{
                            height: "40px !important",
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "white",
                              borderRadius: "4px",
                              "& fieldset": { borderColor: "#ccc" },
                              "&:hover fieldset": { borderColor: "#ff9800" },
                              "&.Mui-focused fieldset": { borderColor: "#fb8c00" },
                            },
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          {...props}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            "&:hover": { backgroundColor: "#fff3e0" },
                          }}
                        >
                          <Typography variant="body2">{option.DocumentName}</Typography>
                        </Box>
                      )}
                      noOptionsText={
                        documentVaultUserFiles.length === 0
                          ? "No documents available in the vault"
                          : "No documents found for this category"
                      }
                      sx={{ backgroundColor: "white" }}
                    />
                  )}
                </FormControl>
              ) : (
                <Typography variant="body2" sx={{ color: "#666", mb: 3 }}>
                  Please select a category to view documents
                </Typography>
              )}

              <Box>
                {tempOtherFiles.length > 0 ? (
                  tempOtherFiles.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px",
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body2">{file.DocumentName || file.name}</Typography>
                      <IconButton
                        onClick={() => setTempOtherFiles([])}
                      >
                        <CloseIcon sx={{ color: "#555" }} />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No files selected
                  </Typography>
                )}
              </Box>
            </>
          ) : (
            <>
              {tempOtherFiles.length > 0 ? (
                tempOtherFiles.map((file, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center", mb: 2 }}
                  >
                    <TextField
                      type="file"
                      onChange={(e) => handleTempOtherFileChange(index, e)}
                      sx={{ flexGrow: 1, mr: 1 }}
                      inputProps={{
                        accept: "application/pdf",
                        "aria-label": `Other File ${index + 1}`,
                      }}
                    />
                    {file && (
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        {file.name}
                      </Typography>
                    )}
                    <IconButton
                      onClick={() => handleRemoveTempOtherFile(index)}
                    >
                      <RemoveIcon
                        sx={{
                          backgroundColor: "#fb8c00",
                          color: "#fff",
                          borderRadius: "24px",
                          width: "35px",
                          height: "35px",
                        }}
                      />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <div className="doc-des">
                  <Button
                    variant="outlined"
                    onClick={handleAddDocOtherFile}
                    sx={{
                      mb: 1,
                      width: "300px",
                      border: "1px solid #FF5722",
                      color: "#fff",
                      textTransform: "capitalize",
                      backgroundColor: "#fb8c00",
                    }}
                  >
                    Upload File from Document Vault
                  </Button>
                  <br />
                  <Button
                    variant="outlined"
                    onClick={handleAddTempOtherFile}
                    sx={{
                      mb: 1,
                      width: "300px",
                      border: "1px solid #FF5722",
                      color: "#fff",
                      textTransform: "capitalize",
                      backgroundColor: "#fb8c00",
                    }}
                  >
                    Upload file from Local Drive
                  </Button>
                </div>
              )}
            </>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmOtherFiles}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
              disabled={tempOtherFiles.length === 0}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>
    </div>
  );
};

export default RaisedTicket;